enum GAME_TYPE {
  Tetris = 'TETRIS',
  Zelda = 'ZELDA',
  SpaceInvaders = 'SPACE_INVADERS',
  Portfolio = 'PORTFOLIO',
}

export { GAME_TYPE };
